import { render, staticRenderFns } from "./TftMatch.vue?vue&type=template&id=9394f598&scoped=true"
import script from "./TftMatch.vue?vue&type=script&lang=js"
export * from "./TftMatch.vue?vue&type=script&lang=js"
import style0 from "./TftMatch.vue?vue&type=style&index=0&id=9394f598&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9394f598",
  null
  
)

export default component.exports